import React from 'react'
import Loading from './loading'
import Pagination from './Pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSort,
  faSortAsc,
  faSortDesc
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

const Table = ({
  columns,
  footer,
  data,
  onSelectedRowsChange,
  selectedRows = [],
  hasCheckBox,
  tableStyle,
  isLoading,
  paginate = true,
  params,
  updateParams,
  onRowClick
}: {
  columns: any
  footer?: any
  data: any
  onSelectedRowsChange?: any
  selectedRows: string[]
  hasCheckBox?: any
  tableStyle?: any
  isLoading?: boolean
  paginate?: boolean
  params?: any
  updateParams?: (key: string, value: any) => void
  onRowClick?: (rowId: any) => void
  //TODO: Remove
  showHeaderIcon?: boolean
}) => {
  const { t } = useTranslation()
  // const [selectedRows, setSelectedRows]: any = useState([])

  // useEffect(
  //   () => {
  //     if (onSelectedRowsChange) onSelectedRowsChange(selectedRows)
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [selectedRows]
  // )

  const handleCheckboxChange = (rowId: any) => {
    if (selectedRows.includes(rowId)) {
      onSelectedRowsChange((prevSelectedRows: any[]) =>
        prevSelectedRows.filter((id) => id !== rowId)
      )
    } else {
      onSelectedRowsChange((prevSelectedRows: any) => [
        ...prevSelectedRows,
        rowId
      ])
    }
  }
  return (
    <>
      <div className='flex flex-col m-1'>
        <div className='-m-1.5 overflow-x-auto'>
          <div className='p-1.5 min-w-full inline-block align-middle'>
            <div className={`overflow-hidden  ${tableStyle}`}>
              <table className='min-w-full'>
                <thead className='text-xs text-gray-700 bg-primary bg-opacity-10'>
                  <tr>
                    {hasCheckBox && (
                      <th
                        scope='col'
                        className='pl-3 py-3 text-start text-xs font-medium text-gray-500 uppercase'
                      >
                        <input
                          type='checkbox'
                          className='border-gray-900 rounded text-[primary] focus:ring-blue-500 '
                          onChange={() =>
                            onSelectedRowsChange(
                              selectedRows.length === data.length ?
                                []
                              : data.map((row: any) => row.id)
                            )
                          }
                          checked={
                            data?.length && selectedRows.length === data?.length
                          }
                        />
                      </th>
                    )}
                    {columns?.map((column: any, i: number) => (
                      <th
                        key={i}
                        scope='col'
                        className={`p-3 text-start text-xs font-medium text-gray-500 capitalize${params?.sort_field === column.key ? ' text-gray-900' : ''}${column.sort ? ' cursor-pointer hover:text-gray-900' : ''}`}
                        onClick={
                          updateParams && column.sort ?
                            () => {
                              updateParams('sort_field', column.key)
                              updateParams(
                                'sort_order',
                                params?.sort_order === 'asc' ? 'desc' : 'asc'
                              )
                            }
                          : undefined
                        }
                      >
                        <div className='flex'>
                          {column.sort && (
                            <FontAwesomeIcon
                              className='mr-1 pt-0.5 text-gray-500'
                              icon={
                                !(params?.sort_field === column.key) ? faSort
                                : params?.sort_order === 'asc' ?
                                  faSortAsc
                                : faSortDesc
                              }
                            />
                          )}
                          <span>{t(column.title)} </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className=' '>
                  {isLoading ?
                    <tr>
                      <td colSpan={columns.length}>
                        <Loading />
                      </td>
                    </tr>
                  : data?.map((row: any, rowIndex: any) => (
                      <tr
                        key={rowIndex}
                        className='hover:bg-gray-100'
                        onClick={(e: any) => {
                          if (e.target.id === 'table-row' && onRowClick)
                            onRowClick(row)
                        }}
                      >
                        {hasCheckBox && (
                          <td className='pl-3 py-3 whitespace-nowrap text-sm border-dotted border-b-2 font-medium text-gray-800 '>
                            <input
                              type='checkbox'
                              checked={selectedRows.includes(row.id)}
                              onChange={() => handleCheckboxChange(row.id)}
                              className='border-gray-900 rounded text-[primary] focus:ring-blue-500 '
                            />
                          </td>
                        )}
                        {columns?.map((column: any, i: number) => (
                          <td
                            key={i}
                            className={`p-3 whitespace-nowrap border-dotted border-b-2  text-sm font-medium text-gray-800 text-ellipsis overflow-hidden max-w-60 ${column.onClick ? 'cursor-pointer hover:text-blue-500' : ''}`}
                            id='table-row'
                            title={
                              (
                                typeof (column.render ?
                                  column.render(row[column.key], row)
                                : row[column.key]) === 'string'
                              ) ?
                                column.render ?
                                  column.render(row[column.key], row)
                                : row[column.key]
                              : null
                            }
                          >
                            {column.onClick ?
                              <span onClick={() => column.onClick(row)}>
                                {column.render ?
                                  column.render(row[column.key], row)
                                : row[column.key]}
                              </span>
                            : column.render ?
                              column.render(row[column.key], row)
                            : row[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))
                  }
                </tbody>
                {footer && (
                  <tfoot className='text-gray-700 bg-primary bg-opacity-10'>
                    <tr>
                      {hasCheckBox && (
                        <th className='pl-3 py-4 whitespace-nowrap text-sm border-dotted border-b-2 font-medium text-gray-800 '></th>
                      )}
                      {columns?.map((column: any, i: number) => (
                        <th
                          key={i}
                          scope='col'
                          className='px-6 py-3 text-start text-xs font-medium text-gray-500 capitalize'
                          title={
                            (
                              typeof (column.render ?
                                column.render(footer[column.key] || '', footer)
                              : footer[column.key]) === 'string'
                            ) ?
                              column.render ?
                                column.render(footer[column.key] || '', footer)
                              : footer[column.key]
                            : null
                          }
                        >
                          {column.render ?
                            column.render(footer[column.key] || '', footer)
                          : footer[column.key]}
                        </th>
                      ))}
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
            {data?.length < 1 && (
              <div className='w-full text-center'>
                <h2 className='mt-5 font-semibold text-gray-800 dark:text-white'>
                  {t('There is no data in this table')}
                </h2>
                {/* <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              Draft an invoice and send it to a customer.
            </p> */}
              </div>
            )}
          </div>
        </div>
      </div>
      {paginate && params && updateParams && (
        <div
          className='flex overflow-x-auto sm:justify-end'
          id='pagination-globle-style'
        >
          <Pagination
            setPageSize={(val: number) => updateParams('page_size', val)}
            setPageNumber={(val: number) => updateParams('page_number', val)}
            currentPage={params.page_number}
            pageSize={params.page_size}
            totalCount={params.count || 0}
          />
        </div>
      )}
    </>
  )
}

export default Table
